export async function getCsrfToken() {
  const response = await fetch("/api/csrf", {
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("Could not get CSRF token");
  }

  return await response.json();
}

export async function getCurrentUser() {
  const response = await fetch("/api/auth/me", {
    credentials: "include",
  });

  if (!response.ok) {
    return null;
  }

  return await response.json();
}

export async function logout() {
  const csrf = await getCsrfToken();

  await fetch("/api/auth/logout", {
    method: "POST",
    credentials: "include",
    headers: {
      [csrf.headerName]: csrf.token,
    },
  });
}